import { refetchFunc } from 'modules/domain/common/hooks'
import { Export } from 'modules/domain/export/types'
import { FC } from 'react'
import styled from 'styled-components'
import { Card } from 'views/components/Card/Card'
import { DealsTable } from '../../components/DealsTable'
import { CommonInfo } from './CommonInfo'
import { CostInfo } from './CostInfo'
import { DocumentFile } from 'modules/domain/types'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px 0;
  padding-bottom: 88px;
`

type Props = {
  exportData: Export
  exportRefetch: refetchFunc
  docsRefetch: refetchFunc
  exportDocs: DocumentFile[]
}

export const ExportLeftBlock: FC<Props> = ({ exportData, exportRefetch, docsRefetch, exportDocs }) => {
  return (
    <Wrapper>
      <Card.Container>
        <Card.Grid cols={2} maxColumnWidth="550px">
          <CommonInfo exportData={exportData} exportDocs={exportDocs} docsRefetch={docsRefetch} />
          <CostInfo exportData={exportData} exportRefetch={exportRefetch} />
        </Card.Grid>
      </Card.Container>
      <DealsTable exportData={exportData} />
    </Wrapper>
  )
}
